import React from "react";
import { SubHeader } from "../../Common/layout/SubHeader";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute } from "../../../../_metronic/layout";
import { Permissions } from "../../../util/Permissions";
import { BalanceRecalculationTable } from "./BalanceRecalculationTable";
import { PendingTransactionTable } from "./PendingTransactionTable";
import { TechResolvedTable } from "./TechResolvedTable";
import { TechSupportTable } from "./TechSupportTable";
import { AllFlaggedTransactionsTable } from "./AllFlaggedTransactionsTable";

export const CompromisedTransactions = ({ match: { params: { userGroup } } }) => {
    return (
        <>

            <SubHeader>
                <SubHeader.Nav>
                    <SubHeader.NavItem label={"Pending Review"} to={`/stalled-transaction/${userGroup}/pending`}>
                        <SubHeader.Nav>
                            <SubHeader.NavItem label={"Pending System Revalidation"} to={`/stalled-transaction/${userGroup}/pending/debt`} />
                            <SubHeader.NavItem label={"Post-Tech Review "} to={`/stalled-transaction/${userGroup}/pending/tech_resolved`} />
                        </SubHeader.Nav>
                    </SubHeader.NavItem>
                    <SubHeader.NavItem label={"Pending Tech Update"} to={`/stalled-transaction/${userGroup}/tech_support`} />
                    <SubHeader.NavItem label={"All"} to={`/stalled-transaction/${userGroup}/all`} />
                </SubHeader.Nav>
            </SubHeader>


            <Switch>
                <Redirect exact from="/stalled-transaction/:userGroup" to="/stalled-transaction/:userGroup/pending" />
                <ContentRoute
                    path="/stalled-transaction/:userGroup/pending"
                    exact
                    permission={Permissions.STALLED_TRANSACTIONS}
                    component={PendingTransactionTable}
                />
                <ContentRoute
                    path="/stalled-transaction/:userGroup/debt"
                    exact
                    permission={Permissions.STALLED_TRANSACTIONS}
                    component={BalanceRecalculationTable}
                />
                <ContentRoute
                    path="/stalled-transaction/:userGroup/tech_resolved"
                    exact
                    permission={Permissions.STALLED_TRANSACTIONS}
                    component={TechResolvedTable}
                />

                <ContentRoute
                    path="/stalled-transaction/:userGroup/tech_support"
                    exact
                    permission={Permissions.STALLED_TRANSACTIONS}
                    component={TechSupportTable}
                />
                <ContentRoute
                    path="/stalled-transaction/:userGroup/all"
                    exact
                    permission={Permissions.STALLED_TRANSACTIONS}
                    component={AllFlaggedTransactionsTable}
                />
            </Switch>
        </>
    );
};
